export default __webpack_public_path__ + "static/media/arrow.5bd4d614.svg";